import { CheckCircle } from "@mui/icons-material";
import { displayOutcomeStatus, displayValidationStatus } from "Backend";
import { cn } from "components/lib/utils";
import { OutcomeStatus, ValidationStatus } from "generated/graphql";
import { HTMLAttributes } from "react";
import { useAppSelector } from "redux/hooks";
import { selectClientLensSBREnabled, selectLensOutcomeStatusConfiguration } from "redux/slices/clientLens";

export function DisplaySectionOutcome({
  outcomeStatus,
  className,
}: { outcomeStatus: OutcomeStatus } & HTMLAttributes<HTMLParagraphElement>) {
  const { sbrEnabled, lensOutcomeStatusConfigurations } = useAppSelector(selectLensOutcomeStatusConfiguration);
  return (
    <div className="flex items-center gap-2">
      {outcomeStatus === OutcomeStatus.Valid && <CheckCircle className="text-gray-900 text-xs" />}
      <p className={"text-xs " + cn("outcome-status-text text-gray-500", className)}>
        {displayOutcomeStatus(outcomeStatus, sbrEnabled, lensOutcomeStatusConfigurations)}
      </p>
    </div>
  );
}

export function DisplayValidationOutcome({
  validationStatus,
  className,
}: { validationStatus: ValidationStatus } & HTMLAttributes<HTMLParagraphElement>) {
  const sbrEnabled = useAppSelector(selectClientLensSBREnabled);
  return (
    <p
      className={
        "text-xs " +
        cn(
          "uppercase text-gray-500 font-semibold tracking-wider",
          validationStatus === ValidationStatus.Issue && "text-red-500",
          className
        )
      }>
      {displayValidationStatus(validationStatus, sbrEnabled)}
    </p>
  );
}

export function DisplayValidationIssue({
  validationStatus,
  className,
}: { validationStatus: ValidationStatus } & HTMLAttributes<HTMLParagraphElement>) {
  const sbrEnabled = useAppSelector(selectClientLensSBREnabled);
  return validationStatus === ValidationStatus.Issue ? (
    <p className={"text-xs " + cn("uppercase text-red-500 font-semibold tracking-wider", className)}>
      {displayValidationStatus(validationStatus, sbrEnabled)}
    </p>
  ) : (
    <></>
  );
}
